import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexCol, FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { __, __r } from 'react-i18n';
import { TextP } from '../../Defaults/Text';
import { InfoText, InfoType } from '../General/InfoText';
import { CheckBox } from '../General/Checkbox';
import { FormInput } from '../Form/FormInput';

interface Props {
  name: string;
  surname: string;
  onChange: (e) => void;
  isCompany: boolean;
  isNameSet: boolean;
  isSurnameSet: boolean;
}

function SanitasContactPersonBlock({
  isNameSet,
  isSurnameSet,
  name,
  surname,
  onChange,
  isCompany,
}: Props) {
  return (
    <Wrapper>
      {isNameSet ? (
        <FieldWrapper>
          <Field>Meno</Field>
          <Value>{name}</Value>
        </FieldWrapper>
      ) : (
        <FormInput
          name={'name'}
          type="text"
          label={'Meno'}
          value={name}
          marginBottom={16}
          onChange={onChange}
          required={true}
        />
      )}
      {isSurnameSet ? (
        <FieldWrapper>
          <Field>Priezvisko</Field>
          <Value>{surname}</Value>
        </FieldWrapper>
      ) : (
        <FormInput
          name={'surname'}
          type="text"
          label={'Priezvisko'}
          value={surname}
          marginBottom={16}
          onChange={onChange}
          required={true}
        />
      )}
      <LastFieldWrapper>
        <Field>Heslo</Field>
        <ValueLink
          to={__r('routes:moj-ucet/zmena-hesla', '/moj-ucet/zmena-hesla')}
        >
          {__('Zmeniť heslo')}
        </ValueLink>
      </LastFieldWrapper>
      {/* turned of for now (until API is ready)*/}
      {false && (
        <InfoText
          noIcon={true}
          type={InfoType.INFO}
          info={'Informácia o expirácii hesla.'}
        />
      )}
      <CheckBox
        name="isCompany"
        onClick={onChange}
        selected={isCompany}
        label={__('Nakupujem na firmu')}
      />
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  padding: ${rem(42)} ${rem(32)} ${rem(32)};

  ${({ theme }) => theme.mediab.m600`
    padding: ${rem(42)} ${rem(16)} ${rem(32)};
  `}
`;

const FieldWrapper = styled(FlexRowCenterVertical)`
  margin-bottom: ${rem(16)};
`;

const LastFieldWrapper = styled(FieldWrapper)`
  margin-bottom: ${rem(32)};
  margin-top: ${rem(16)};
`;

const Text = styled(TextP)`
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.black};
  line-height: ${rem(22)};
`;

const Field = styled(Text)`
  line-height: ${rem(17)};
  margin-right: ${rem(24)};
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  margin-right: ${rem(16)};
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 400;
`;

const Value = styled(Text)`
  font-weight: 400;
`;

const ValueLink = styled(Link)`
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 400;
  text-decoration: underline;
`;

export { SanitasContactPersonBlock };
